import * as moment from 'moment';
/**
 * This function will take a `Date` object, which is going to be in the system's
 * local time zone, and convert it to a an ISO8601 format in the UTC timezone.
 *
 * e.g.
 * dateToString(new Date("2018-01-02T00:00:00+0200"))
 * "2018-01-01T22:00:00+0000Z"
 *
 * This function should be used whenever we are converting a local date object
 * to a string for the purposes of sending to the api.
 *
 * @param date {Date}
 * @returns {string}
 */
export const dateToString = (date: Date): string => {

    if (!date) {
        return undefined;
    }

    return moment(date).toISOString();
};



// WEBPACK FOOTER //
// ./src/core/util/date-to-string.ts